import React from "react";
import Navbar from "../header";
import Footer from "../footer";

const AboutUs = () => {
    return (

        <>

        <Navbar  menuColor="red" />

        <div  > </div>


        <div className="bg-light">

            {/* Hero Section */}
            <section className="py-5 bg-primary text-white">
                <div className="container text-center">
                    <h1 className="fw-bold">About Us</h1>
                    <p className="mt-3 fs-5">
                        Connecting patients with trusted medical professionals — anytime, anywhere.
                    </p>
                </div>
            </section>

            {/* Who We Are */}
            <section className="py-5">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-md-6">
                            <h2 className="fw-bold text-primary">Who We Are</h2>
                            <p className="text-muted mt-3">
                                We are a digital medical consultation platform designed to bridge the
                                gap between patients and licensed healthcare professionals. Our goal
                                is to make quality healthcare accessible, convenient, and secure
                                for everyone.
                            </p>
                            <p className="text-muted">
                                Through our platform, patients can consult doctors, receive medical
                                advice, and manage their health without unnecessary delays or
                                geographical limitations.
                            </p>
                        </div>
                        <div className="col-md-6 text-center">
                            <img
                                src="/slidders/about_us_pic.png"
                                alt="Healthcare team"
                                className="img-fluid rounded-4 shadow"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Mission & Vision */}
            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row g-4 text-center">
                        <div className="col-md-6">
                            <div className="card border-0 shadow h-100 rounded-4">
                                <div className="card-body p-4">
                                    <h4 className="fw-semibold text-primary">Our Mission</h4>
                                    <p className="text-muted mt-3">
                                        To provide accessible, affordable, and reliable healthcare
                                        through innovative digital solutions while maintaining the
                                        highest medical and ethical standards.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="card border-0 shadow h-100 rounded-4">
                                <div className="card-body p-4">
                                    <h4 className="fw-semibold text-primary">Our Vision</h4>
                                    <p className="text-muted mt-3">
                                        To become a leading digital healthcare platform that empowers
                                        individuals to take control of their health with confidence and trust.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold text-primary">Why Choose Us</h2>
                        <p className="text-muted mt-2">
                            We prioritise quality, security, and patient satisfaction
                        </p>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="card h-100 border-0 shadow rounded-4 text-center">
                                <div className="card-body p-4">
                                    <h5 className="fw-semibold">Certified Doctors</h5>
                                    <p className="text-muted mt-2">
                                        All doctors on our platform are verified and licensed
                                        professionals with proven experience.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border-0 shadow rounded-4 text-center">
                                <div className="card-body p-4">
                                    <h5 className="fw-semibold">Secure Consultations</h5>
                                    <p className="text-muted mt-2">
                                        We use secure technologies to protect your personal and
                                        medical information at all times.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border-0 shadow rounded-4 text-center">
                                <div className="card-body p-4">
                                    <h5 className="fw-semibold">24/7 Accessibility</h5>
                                    <p className="text-muted mt-2">
                                        Consult with healthcare professionals at your convenience,
                                        from the comfort of your home.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Trust & Compliance */}
            <section className="py-5 bg-primary text-white">
                <div className="container text-center">
                    <h2 className="fw-bold">Trust, Privacy & Compliance</h2>
                    <p className="mt-3 fs-6">
                        We strictly follow healthcare regulations and data protection standards
                        to ensure your information remains confidential and secure.
                    </p>
                </div>
            </section>

        </div>

        <Footer />

        </>
    );
};

export default AboutUs;
